import { action } from '@ember/object';
import Component from '@glimmer/component';

import FormCheckboxSwitchComponent from 'webapp/components/form/checkbox-switch';

import type Block from 'webapp/models-custom/block';

interface Args {
	blockM: Block;
}

export default class BlockSettingsNumberRowsComponent extends Component<Args> {
	get block(): Block {
		return this.args.blockM;
	}

	get selected(): boolean {
		return !!this.block.hasRowNumbers;
	}

	@action
	changeSelected(selected: boolean): void {
		const block = this.block;
		block.hasRowNumbers = selected;
		block.blockSetup.saveBlock();
	}
	<template>
		<div class="row row--toggle">
			<FormCheckboxSwitchComponent
				@name="numberRows"
				@selected={{this.selected}}
				@onChange={{this.changeSelected}}
			/>
			<label>Number rows</label>
		</div>
	</template>
}
